import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { EpaycoPageRoutingModule } from './epayco-routing.module';

import { EpaycoPage } from './epayco.page';
import { SharedModule } from '../../shared/shared.module'; 


//import { CurrencyPipe } from '@angular/common';
/*import localeCO from "@angular/common/locales/es-CO";
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeCO, "COP");*/

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    IonicModule,
    EpaycoPageRoutingModule,
    ReactiveFormsModule,
    //localeCO,
    //CurrencyPipe
  ],
  //declarations: [EpaycoPage,localeCO,CurrencyPipe]
  declarations: [EpaycoPage]
})

export class EpaycoPageModule {}
